import { useMemo } from 'react'
import type {
  VehicleOrdersRequest,
  OrderDetailsFinanceApplicationStatus,
  OrderDetailsStatus,
  Vehicle,
} from '../types'

type LiveFinanceOfferOrder = {
  vehicle: Vehicle
  orderId: string
  financeId?: string
  financeStatus?: OrderDetailsFinanceApplicationStatus
}

export function useFinanceOfferOrder(
  vehicleOrders: VehicleOrdersRequest | undefined,
): LiveFinanceOfferOrder | undefined {
  return useMemo(() => {
    if (!vehicleOrders || !vehicleOrders.orders) {
      return
    }

    const liveFinanceStatus = new Set<OrderDetailsFinanceApplicationStatus>([
      'ApplicationApproved',
      'ApplicationDepositReceived',
      'ESignComplete',
    ])
    const liveOrderStatus = new Set<OrderDetailsStatus>([
      'InProgress',
      'AwaitingFinanceDecision',
      'Fulfilled',
      'ReadyToComplete',
      'AwaitingFinanceDeposit',
    ])
    const validOrders = vehicleOrders.orders.filter(
      (order) =>
        liveOrderStatus.has(order.orderStatus) &&
        order.financeApplication?.status !== undefined &&
        liveFinanceStatus.has(order.financeApplication.status),
    )
    if (!validOrders || validOrders.length === 0) return

    const latestVehicle = validOrders.sort(
      (a, b) => b.createdAt - a.createdAt,
    )[0]

    return {
      vehicle: latestVehicle.vehicle,
      orderId: latestVehicle.id,
      financeId: latestVehicle.financeApplication?.id,
      financeStatus: latestVehicle.financeApplication?.status,
    }
  }, [vehicleOrders])
}
